import { useSearchParams } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MedicationsPanel from "@/pages/Medications";
import RefillsPanel from "@/pages/RefillRequest";

export default function Meds({ initialTab }) {
  const [params] = useSearchParams();
  const tab = initialTab || params.get("tab") || "medications";

  return (
    <div className="max-w-lg mx-auto px-4 py-6 animate-fade-in" data-testid="meds-page">
      <PageHeader title="Meds" subtitle="Your medications and refills, in one place" />
      <Tabs defaultValue={tab} className="w-full">
        <TabsList className="w-full mb-4">
          <TabsTrigger value="medications" className="flex-1" data-testid="meds-tab-medications">Medications</TabsTrigger>
          <TabsTrigger value="refills" className="flex-1" data-testid="meds-tab-refills">Refills</TabsTrigger>
        </TabsList>
        <TabsContent value="medications">
          <MedicationsPanel />
        </TabsContent>
        <TabsContent value="refills">
          <RefillsPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
